export interface IAuthState {
    readonly userId: number | null;
    readonly userName: string | null;
    readonly displayName: string | null;
}
